import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {BalanceEvent} from "@nolimitcity/slot-game/bin/core/balance/event/BalanceEvent";
import {HorribleHeroesReelController} from "./HorribleHeroesReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";

export class HorribeHeroesReelAreaView extends ReelAreaView {
    constructor(resourcesGroup?: ResourcesGroupName) {
        super(resourcesGroup);
        EventHandler.addEventListener(this, BalanceEvent.BET, () => this.updateMaskOnSpin());
        EventHandler.addEventListener(this, SpinEvent.STOPPED, () => this.onAllSpinStopped());
    }

    private onAllSpinStopped() {
        this._mask = null!;
        (<HorribleHeroesReelController>Reels.getReel(0)).hideOverFlowSyms([1, 2, 3, 4]);
        (<HorribleHeroesReelController>Reels.getReel(1)).hideOverFlowSyms([1, 2, 3, 4]);
        (<HorribleHeroesReelController>Reels.getReel(2)).hideOverFlowSyms([1, 2, 3, 4]);
        (<HorribleHeroesReelController>Reels.getReel(3)).hideOverFlowSyms([1, 2, 3, 4]);
        (<HorribleHeroesReelController>Reels.getReel(4)).hideOverFlowSyms([1, 2, 3, 4]);
    }

    private updateMaskOnSpin() {
        super.UpdateReelAreaMask();

        this._reelViews.forEach((reelView) => {
            reelView.children.forEach((child) => {
                child.visible = true;
            })
        });
    }
}